import { ShareNetwork, Copy } from "@phosphor-icons/react";
import { copyText, shareProduct } from "../lib/share";

export function CopySkuButton({ sku, size = 12, className = "", testId }) {
    return (
        <button
            type="button"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                copyText(sku, "SKU copied.");
            }}
            data-testid={testId || `copy-sku-${sku}`}
            title="Copy SKU"
            className={`inline-flex items-center justify-center text-neutral-400 hover:text-sage-dark transition-colors ${className}`}
            aria-label={`Copy SKU ${sku}`}
        >
            <Copy size={size} weight="light" />
        </button>
    );
}

/**
 * Single-tap native Share button.
 *
 * Tapping opens the device's native share sheet via the Web Share API —
 * recipients choose any installed destination (iMessage, WhatsApp, LINE,
 * Telegram, Email, AirDrop, etc.). No custom app list, no WhatsApp-specific
 * integration. On unsupported browsers it quietly falls back to copying the
 * public product link.
 */
export function ShareMenu({ product, iconOnly = false, className = "" }) {
    const onShare = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await shareProduct(product);
    };
    return (
        <button
            type="button"
            onClick={onShare}
            data-testid={`share-${product.sku}`}
            aria-label="Share product"
            title="Share"
            className={`inline-flex items-center gap-1 text-neutral-500 hover:text-sage-dark transition-colors ${className}`}
        >
            <ShareNetwork size={14} weight="light" />
            {!iconOnly && <span className="text-[11px] uppercase tracking-widest">Share</span>}
        </button>
    );
}
